module.exports = __webpack_public_path__ + "static/media/loading_save.94b39c9b.svg";